export enum PagesList {
  HOME_APPRAISAL = 'home-appraisal',
  REGISTRATION = 'registration'
}

export type Pages =
  PagesList.REGISTRATION |
  PagesList.HOME_APPRAISAL;
